import _ from "lodash";
import React, { useCallback, useMemo, memo } from "react";
import { useI18n } from "Hooks";
import { ConfigureColumnsOutlined } from "@toddle-edu/ds-icons";
import { Dropdown, IconButton, Tooltip } from "@toddle-edu/ds-web";
import ConfigureColumnsOverlay from "UIComponents/ConfigureColumnsOverlay/ConfigureColumnsOverlay";

const ConfigureColumns = memo(props => {
  const {
    testId,
    currentColumns,
    updateColumns,
    columnIdsForConfigureModal,
    properties,
  } = props;

  const { t } = useI18n();

  const data = useMemo(() => {
    return _.map(columnIdsForConfigureModal, columnId => {
      const columnHeaderConfig = properties[columnId]?.headerConfig || {};

      const { title, titleForConfigureColumns } = columnHeaderConfig;

      return {
        id: columnId,
        value: titleForConfigureColumns || title,
      };
    });
  }, [properties, columnIdsForConfigureModal]);

  const onSelectColumn = useCallback(
    selectedCols =>
      updateColumns({
        columnOrder: data,
        selectedColumns: selectedCols,
      }),
    [data, updateColumns]
  );

  const onReorderColumns = useCallback(
    updatedColumns =>
      updateColumns({
        columnOrder: updatedColumns,
        selectedColumns: currentColumns,
      }),
    [currentColumns, updateColumns]
  );

  return (
    <Dropdown
      overlay={
        <ConfigureColumnsOverlay
          data={data}
          selectedColumns={currentColumns}
          onSelectColumn={onSelectColumn}
          onReorderColumns={onReorderColumns}
          testId={`${testId}-configureColumns`}
        />
      }
      placement="bottomRight"
    >
      <Tooltip placement="bottom" tooltip={t("common:configure_columns")}>
        <IconButton
          icon={<ConfigureColumnsOutlined />}
          type="outlined"
          variant="neutral"
          testId={`${testId}-configureColumns`}
        />
      </Tooltip>
    </Dropdown>
  );
});

ConfigureColumns.displayName = "ConfigureColumns";

export default ConfigureColumns;
